import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Only redirect if we're at the root path without .html extension
    const path = window.location.pathname;
    if (path === '/' || path === '/index' || path === '') {
      window.location.replace("/index.html");
    }
  }, []);

  // Return null to avoid rendering anything - the static HTML content is already there
  return null;
}

export default App;
